var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5317",
    "data-name": "Group 5317",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 18.211,
    viewBox: "0 0 13 18.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5315",
    "data-name": "Group 5315",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3555",
    "data-name": "Path 3555",
    d: "M1080.469,557.211a.42.42,0,0,1-.4-.29,13.189,13.189,0,0,0-3.255-5.1c-1.463-1.609-2.845-3.129-2.845-5.976a6.509,6.509,0,1,1,13,0c0,2.847-1.382,4.367-2.845,5.976a13.191,13.191,0,0,0-3.255,5.1A.42.42,0,0,1,1080.469,557.211Zm0-17.371a5.712,5.712,0,0,0-5.66,6.006c0,2.523,1.217,3.861,2.627,5.411a15.175,15.175,0,0,1,3.033,4.344,15.18,15.18,0,0,1,3.033-4.344c1.41-1.55,2.627-2.889,2.627-5.411A5.712,5.712,0,0,0,1080.469,539.84Z",
    transform: "translate(-1073.969 -539)",
    fill: "#ffc629"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5316",
    "data-name": "Group 5316",
    transform: "translate(3.298 3.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M1084.995,553.272a3.16,3.16,0,1,1-.017-6.32h0a3.16,3.16,0,1,1,.012,6.32Zm-.017-5.48a2.268,2.268,0,0,0-2.316,2.317,2.32,2.32,0,1,0,4.64,0,2.268,2.268,0,0,0-2.315-2.317Z",
    transform: "translate(-1081.822 -546.952)",
    fill: "#ffc629"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.64f5a813552da3371bb33c2f2e0f634b.svg";
export { ForwardRef as ReactComponent };